import { useEffect, useRef, EffectCallback, DependencyList } from 'react';
import { LzTFunctionSimple } from '@lz/typings/types';

/**
 * Hook definition for OnMount event.
 *
 * @param onMount LzTFunctionSimple
 *
 * @return void
 */
export const useLzOnMount = (onMount: LzTFunctionSimple) => {
  return useEffect(() => {
    if (typeof onMount === 'function') {
      onMount();
    }
  }, []);
};

/**
 * Hook definition for Effect event after Mount.
 *
 * @param callback EffectCallback
 * @param dependencies DependencyList
 *
 * @return void
 */
export const useLzEffectAfterMount = (
  callback: EffectCallback,
  dependencies: DependencyList
) => {
  const mounted4EffectAfterMount = useRef(true);

  // NOTE: For some reason this hook is not working good, misses even if its after mount
  // May be its that:
  //                  - when something inside a render check is called after mount the ref is not set
  //                  - so the flag mounted4EffectAfterMount is not effective if used for something that is shown/hidden with another flag

  useEffect(() => {
    if (!mounted4EffectAfterMount.current) {
      return callback();
    }
    mounted4EffectAfterMount.current = false;
  }, dependencies);
};

/**
 * Hook definition for OnUnmount event.
 *
 * @param onUnmount LzTFunctionSimple
 *
 * @return void
 */
export const useLzOnUnmount = (onUnmount: LzTFunctionSimple) => {
  return useEffect(() => {
    return () => onUnmount && onUnmount();
  }, []);
};
